import { FC } from 'react'
import {
    TimestampContainer,
    TimeStampColumn,
    DateContainer
} from '../style/post-page'
import styled from 'styled-components'
import { tokens } from '@JOTAJornalismo/jota-design-system'
const { colors } = tokens
type TimestampProps = {
    datePost: {
        date: string
        time: string
    }
}

export const Timestamp: FC<TimestampProps> = ({ datePost }) => {
    return (
        <TimestampContainer>
            <TimeStampColumn>
                <DateContainer>
                    <DatePostTag>{datePost.date}</DatePostTag>
                    <span className='divisor'>|</span>
                    <span>{datePost.time}</span>
                </DateContainer>
            </TimeStampColumn>
        </TimestampContainer>
    )
}

const DatePostTag = styled.span`
    font-weight: 400;
    color: ${colors.gray.jotaGrayDarker};
`
